(function () {
  "use strict";

  if (window.__gicleeArtistBiographyLoaded) return;
  window.__gicleeArtistBiographyLoaded = true;

  var GAB_MS = 880;
  var panelRegistry = [];

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function getHandleFromPath() {
    var match = String(window.location.pathname).match(/\/collections\/([^/?#]+)/i);
    return match ? match[1] : "";
  }

  function findLegacyBioSection() {
    var exhibition = document.querySelector("[data-gacs-exhibition]");
    if (!exhibition) return null;

    var gallerySection = exhibition.closest(".shopify-section");
    if (!gallerySection) return null;

    var el = gallerySection.previousElementSibling;
    while (el) {
      if (!el.classList || !el.classList.contains("shopify-section")) {
        el = el.previousElementSibling;
        continue;
      }

      var title = el.querySelector("h1");
      var body = el.querySelector("rte-formatter") || el.querySelector(".rte");
      if (title && body) {
        return {
          root: el,
          titleEl: title,
          bodyEl: body,
          bodyInner: body.querySelector("div") || body,
          isLegacy: true,
        };
      }
      break;
    }
    return null;
  }

  function resolveBioPanels() {
    var panels = [];

    document.querySelectorAll("[data-giclee-artist-bio]").forEach(function (root) {
      panels.push({
        root: root,
        titleEl: root.querySelector('[data-gab-field="title"]'),
        bodyEl: root.querySelector('[data-gab-field="body"]'),
        bodyInner: root.querySelector(".giclee-artist-bio__body-inner"),
        isLegacy: false,
      });
    });

    if (!panels.length) {
      var legacy = findLegacyBioSection();
      if (legacy) panels.push(legacy);
    }

    return panels;
  }

  function GicleeArtistBiography(panel) {
    this.root = panel.root;
    this.titleEl = panel.titleEl;
    this.bodyEl = panel.bodyEl;
    this.bodyInner = panel.bodyInner;
    this.isLegacy = !!panel.isLegacy;
    this.state = null;
    this.inView = false;
    this.transitioning = false;
    this.unsub = null;
    this.io = null;

    if (!this.bodyEl) return;

    if (!this.root.getAttribute("data-gab-handle")) {
      this.root.setAttribute("data-gab-handle", getHandleFromPath());
    }

    if (this.isLegacy) {
      this.root.classList.add("giclee-artist-bio", "giclee-artist-bio--legacy");
    }

    this.onChange = this.onAuthorChange.bind(this);
    this.bindVisibility();
    this.bindState();
  }

  GicleeArtistBiography.prototype.bindState = function () {
    var self = this;
    var attempts = 0;

    function attach() {
      if (!window.GicleeActiveAuthor) {
        attempts += 1;
        if (attempts < 80) {
          window.setTimeout(attach, 50);
        }
        return;
      }
      if (self.unsub) {
        self.unsub();
        self.unsub = null;
      }
      self.state = window.GicleeActiveAuthor;
      self.unsub = self.state.subscribe(self.onChange);
    }

    attach();
  };

  GicleeArtistBiography.prototype.bindVisibility = function () {
    var self = this;
    var observeTarget = this.isLegacy
      ? this.root.querySelector(".section") || this.root
      : this.root;

    if (!("IntersectionObserver" in window)) {
      this.inView = false;
      return;
    }

    this.io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          self.inView = entry.isIntersecting;
          self.root.classList.toggle("is-in-view", self.inView);
        });
      },
      { root: null, threshold: 0.08 }
    );
    this.io.observe(observeTarget);
  };

  GicleeArtistBiography.prototype.clearStates = function () {
    this.root.classList.remove(
      "is-transitioning",
      "is-exiting-next",
      "is-exiting-prev",
      "is-entering-next",
      "is-entering-prev"
    );
  };

  GicleeArtistBiography.prototype.applyContent = function (artist) {
    if (!artist) return;

    var html = artist.bioHtml || "";
    if (!html) return;

    if (this.titleEl) {
      this.titleEl.textContent = artist.artistName || "";
    }

    if (this.isLegacy) {
      if (this.bodyInner) {
        this.bodyInner.innerHTML = html;
      } else if (this.bodyEl) {
        this.bodyEl.innerHTML = html;
      }
    } else if (this.bodyInner) {
      this.bodyInner.innerHTML = html;
    } else if (this.bodyEl) {
      this.bodyEl.innerHTML =
        '<div class="giclee-artist-bio__body-inner">' + html + "</div>";
      this.bodyInner = this.bodyEl.querySelector(".giclee-artist-bio__body-inner");
    }

    this.root.setAttribute("data-gab-handle", artist.handle || "");
  };

  GicleeArtistBiography.prototype.waitTransition = function (callback) {
    var target = this.bodyInner || this.bodyEl;
    if (!target || !this.inView || prefersReducedMotion()) {
      callback();
      return;
    }

    var finished = false;
    var done = function () {
      if (finished) return;
      finished = true;
      target.removeEventListener("transitionend", onEnd);
      callback();
    };
    var onEnd = function (e) {
      if (e.target !== target) return;
      if (e.propertyName !== "opacity" && e.propertyName !== "transform") return;
      done();
    };

    target.addEventListener("transitionend", onEnd);
    window.setTimeout(done, GAB_MS + 120);
  };

  GicleeArtistBiography.prototype.onAuthorChange = function (evt) {
    if (!evt || !evt.artist) return;
    if (this.root.getAttribute("data-gab-handle") === evt.artist.handle) return;
    if (this.transitioning) return;
    if (!evt.artist.bioHtml) return;

    var self = this;
    var dir = evt.direction >= 0 ? 1 : -1;
    var artist = evt.artist;

    if (!this.inView || prefersReducedMotion()) {
      this.clearStates();
      this.applyContent(artist);
      return;
    }

    this.transitioning = true;
    this.clearStates();
    this.root.classList.add("is-transitioning");
    this.root.classList.add(dir > 0 ? "is-exiting-next" : "is-exiting-prev");

    this.waitTransition(function () {
      self.applyContent(artist);
      self.root.classList.remove("is-exiting-next", "is-exiting-prev");

      void self.root.offsetHeight;
      self.root.classList.add(dir > 0 ? "is-entering-next" : "is-entering-prev");

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          self.root.classList.remove("is-entering-next", "is-entering-prev");
          self.waitTransition(function () {
            self.root.classList.remove("is-transitioning");
            self.transitioning = false;
          });
        });
      });
    });
  };

  GicleeArtistBiography.prototype.destroy = function () {
    if (this.unsub) this.unsub();
    if (this.io) this.io.disconnect();
  };

  function boot() {
    resolveBioPanels().forEach(function (panelConfig) {
      var root = panelConfig.root;
      var existing = null;
      for (var i = 0; i < panelRegistry.length; i++) {
        if (panelRegistry[i].root === root) {
          existing = panelRegistry[i];
          break;
        }
      }
      if (existing) {
        existing.bindState();
        return;
      }
      var instance = new GicleeArtistBiography(panelConfig);
      if (instance.bodyEl) {
        panelRegistry.push(instance);
      }
    });
  }

  window.GicleeArtistBiographyBoot = boot;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
